module.exports = __webpack_public_path__ + "img/icon_uebersetzung.429ccbad.png";